import { AllowedCallTypes, CrudConfig } from "seneca-common/utils/apiStates";

export const locationsCrudStateConfig: CrudConfig = {
  name: "locations",
  path: "seneca/locations/meta",
  callTypes: [AllowedCallTypes.FETCH_ALL]
};

export const PATH_TO_LOCATIONS_STATE = "locations";
